/**
 * @generated SignedSource<<7122e0be96e2941d3d8936d1014528e8>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type moreButton_softwareReleasesVersionDetailIssueList_jiraVersion$data = {
  readonly canAddAndRemoveIssues: boolean | null | undefined;
  readonly id: string;
  readonly project: {
    readonly id: string;
  };
  readonly " $fragmentType": "moreButton_softwareReleasesVersionDetailIssueList_jiraVersion";
};
export type moreButton_softwareReleasesVersionDetailIssueList_jiraVersion$key = {
  readonly " $data"?: moreButton_softwareReleasesVersionDetailIssueList_jiraVersion$data;
  readonly " $fragmentSpreads": FragmentRefs<"moreButton_softwareReleasesVersionDetailIssueList_jiraVersion">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "moreButton_softwareReleasesVersionDetailIssueList_jiraVersion",
  "selections": [
    {
      "kind": "RequiredField",
      "field": (v0/*: any*/),
      "action": "THROW",
      "path": "id"
    },
    {
      "kind": "ScalarField",
      "name": "canAddAndRemoveIssues"
    },
    {
      "kind": "RequiredField",
      "field": {
        "concreteType": "JiraProject",
        "kind": "LinkedField",
        "name": "project",
        "plural": false,
        "selections": [
          {
            "kind": "RequiredField",
            "field": (v0/*: any*/),
            "action": "THROW",
            "path": "project.id"
          }
        ]
      },
      "action": "THROW",
      "path": "project"
    }
  ],
  "type": "JiraVersion"
};
})();

(node as any).hash = "e838cd21a0e90d2500f678bc796ae098";

export default node;
